import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TunnelSanteBlockHeaderComponent } from './components/tunnelsante-block/tunnelsante-block-header/tunnelsante-block-header.component';
import { TunnelSanteBlockTitleComponent } from './components/tunnelsante-block/tunnelsante-block-title/tunnelsante-block-title.component';
import { TunnelSanteBlockComponent } from './components/tunnelsante-block/tunnelsante-block.component';
import { TunnelSantePageHeaderComponent } from './components/tunnelsante-page/tunnelsante-page-header/tunnelsante-page-header.component';
import { TunnelSantePageTitleComponent } from './components/tunnelsante-page/tunnelsante-page-title/tunnelsante-page-title.component';
import { TunnelSantePageComponent } from './components/tunnelsante-page/tunnelsante-page.component';

const components = [
  TunnelSantePageComponent,
  TunnelSantePageHeaderComponent,
  TunnelSantePageTitleComponent,
  TunnelSanteBlockComponent,
  TunnelSanteBlockHeaderComponent,
  TunnelSanteBlockTitleComponent,
];
@NgModule({
  imports: [CommonModule, MatIconModule, MatButtonModule],
  declarations: [...components],
  exports: [...components],
})
export class TunnelSanteLayoutModule {}
